export const keycloakJsConfig = {
  url: process.env.VUE_APP_KEYCLOAK_JS_URL ?? '',
  realm: process.env.VUE_APP_KEYCLOAK_JS_REALM ?? '',
  clientId: process.env.VUE_APP_KEYCLOAK_JS_CLIENT_ID ?? ''
}

export const serviceConfig = {
  refreshTokenMilliseconds: process.env.VUE_APP_REFRESH_TOKEN_MS ?? 50000
}
